<span
  class="icon {{ extraClass }}"
  [inlineSVG]="path"
  [setSVGAttributes]="{ class: 'h-full w-[unset]' }"
></span>
